import getTypes from './typesFactory';
import adminImportPageInitialState from './adminImportPage.initialState';

const getAdminReducer = (pageName, { customReducer = state => state } = {}) => {
  const {
    FETCH_ENTITIES,
    FETCH_ENTITIES_SUCCESS,
    FETCH_ENTITIES_FAILURE,
    SAVE_ENTITY,
    SAVE_ENTITY_SUCCESS,
    SAVE_ENTITY_FAILURE,
    REMOVE_ENTITY,
    REMOVE_ENTITY_SUCCESS,
    REMOVE_ENTITY_FAILURE,
    UPLOAD_ENTITIES,
    UPLOAD_ENTITIES_SUCCESS,
    UPLOAD_ENTITIES_FAILURE,
    IMPORT_ENTITIES,
    IMPORT_ENTITIES_SUCCESS,
    IMPORT_ENTITIES_FAILURE,
    CLEAR_UPLOADED_ENTITIES,
  } = getTypes(pageName);

  const reducer = (oldState, action = {}) => {
    const state = oldState ? oldState : adminImportPageInitialState;

    switch (action.type) {
      case FETCH_ENTITIES:
        return {
          ...state,
          fetchingEntities: true,
        };
      case FETCH_ENTITIES_SUCCESS:
        return {
          ...state,
          fetchingEntities: false,
          entities: action.entities,
        };
      case FETCH_ENTITIES_FAILURE:
        return {
          ...state,
          fetchingEntities: false,
        };
      case SAVE_ENTITY:
        return {
          ...state,
          savingEntity: true,
        };
      case SAVE_ENTITY_SUCCESS:
      case SAVE_ENTITY_FAILURE:
        return {
          ...state,
          savingEntity: false,
        };
      case REMOVE_ENTITY:
        return {
          ...state,
          removingEntity: true,
        };
      case REMOVE_ENTITY_SUCCESS:
      case REMOVE_ENTITY_FAILURE:
        return {
          ...state,
          removingEntity: false,
        };
      case UPLOAD_ENTITIES:
        return {
          ...state,
          uploadingEntities: true,
          uploadedEntities: [],
        };
      case UPLOAD_ENTITIES_SUCCESS:
        return {
          ...state,
          uploadingEntities: false,
          uploadedEntities: action.uploadedEntities,
        };
      case UPLOAD_ENTITIES_FAILURE:
        return {
          ...state,
          uploadingEntities: false,
        };
      case IMPORT_ENTITIES:
        return {
          ...state,
          importingEntities: true,
        };
      case IMPORT_ENTITIES_SUCCESS:
        return {
          ...state,
          importingEntities: false,
          uploadedEntities: [],
        };
      case IMPORT_ENTITIES_FAILURE:
        return {
          ...state,
          importingEntities: false,
        };
      case CLEAR_UPLOADED_ENTITIES:
        return {
          ...state,
          uploadedEntities: [],
        };
      default: {
        const stateToMerge = customReducer(oldState, action);

        if (stateToMerge !== oldState) {
          return {
            ...state,
            ...stateToMerge,
          };
        }
        return state;
      }
    }
  };

  return reducer;
};

export default getAdminReducer;
